
A short history:
- 12-22-1993
  - Johns Hopkins, Baltimore, Maryland
  - winter solstice on 12-21-1993 20:36
- 1993-12-22 through Summer 1999
  - River Hill, Columbia, Maryland
  - black eyed susans
  - tadpoles
  - community pool
  - Pokemon cards
  - Magic the Gathering
- Summer 1999+
  - Roswell, Georgia
  - 4+ GPA
  - 7th out of 420 students in my grade
- Thanksgiving 2011
  - early acceptance to Georgia Tech
- December 19, 2011
  - 大麻 and my first beer
- May 2012 graduation
- Summer 2012 BlueLinxCo
  - Ford Explorer down to Georgia Tech
  - Fiji, Sigma Nu, ATO, PDT
- Spring 2013
  - lacrosse
- Summer 2013
  - BlueLinxCo data ecommerce
- Spring 2014
  - GTRI Angular 1.x promises
- Summer 2014
  - Barcelona round 1
- Summer 2015
  - Barcelona round 2 with Ashley and Glovo starting
- August 2015
  - Vipassana meditation Jesup, GA
- Fall 2015
  - Bring Jimmy home
- Spring 2016
  - Glovo round 2 with 2 million dollars of funding
- August 2016 back home
- January/February 2017
  - FIXD app
- Winter 2017
  - graduation from Georgia tech
  - video included?
- early December 2017
  - phone call from Grandma and Grandpa about getting tires for my truck $650
- December 21, 2017
  - Andy Philbert phone call for InRhythm
- Mid January 2018
  - packed up and moved to NYC
- Summer 2018
  - first talks with Amplify about full time work
- January/February 2019
  - waited for bonus and then left InRhythm
- March/April 2019
  - Ambulnz
- May 2019
  - Amplify

Family tree:
- GEDCOM?
- what does 23andME use for theirs?
  - X chromosome on the left (egg)
  - X/Y chromosome "chooser" (sperm)
- Battaglia
  - Sicilian and Southern Italian?

Career:
- East Cobb Lawn Mower
  - 14 years old
- Pizza Man Express
  - 16/17 years old?
- BlueLinx Co
  - 18 years old
  - customer service
  - NATO callsigns
  - Home Depot and Lowes
  - 128 phonecalls in a day
  - 1 phone call every 8 minutes
- BlueLinx Co
  - 19 years old data entry and filtering for new ecommerce platform
  - convert to Google Sheets
- GTRI
  - Java, Spring, Angular 1.x
  - secret security clearance
- Glovo
  - 2014
  - 2015
  - Jan 2016 - August 2016 web lead, SQL analytics for Cyfe
- FIXD
  - Ruby on Rails
  - GiddyUp marketing
- InRhythm
  - consulting
  - Amplify (lead with 1 other Edd)
    - built a "CMS -> printing press" using Java and Python together
    - isomorphic JavaScript layer for sharing code with frontend and backend
  - American Express, Goldman Sachs, etc
- Ambulnz
  - 1.5 months
- Amplify
  - 1 year
  - LMS + Google Slides + PDF.js + React + Presentation API
- AB InBev
  - Lead Software Engineer
  - consultants
    - Microsoft Consultants
    - Kumulus Consultants
    - McFadyen
  - tech/products
    - Mirakl
    - Akeneo
    - Magento
  - initiatives
    - redesign
    - Modelorama (customer groups)
    - Mirakl and global marketplace
  - Bees? Global Marketplace for AB InBev?
  - 54 billion dollar net revenue based on Forbes
